<template>
  <div class="modal-dialog">
    <div class="modal-container">
      <header>
        <span>关于【ftrip】微信功能运营主体变更及隐私政策更新的公告</span>
        <div>
          <i class="el-icon el-dialog__close" @click="$emit('closeDialog')"
            ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
              <path
                fill="currentColor"
                d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
              ></path></svg
          ></i>
        </div>
      </header>
      <div class="dialog-body">
        <div class="simple-notice">
          <p><strong>尊敬的【ftrip】用户：</strong></p>

          <p>
            感谢您长期以来的支持与信任。为适应公司业务发展需要，我们对应用的运营主体进行了调整。
            本次变更涉及您的个人信息处理者发生变化，我们将严格遵守《中华人民共和国个人信息保护法》等法律法规，保障您的个人信息权益。
            现将相关事宜公告如下：
          </p>

          <h3>一、变更内容概述</h3>
          <p>
            自 【2025年12月20日】
            起，本应用的微信支付、微信登录功能运营主体将由原主体
            <strong>【成都百弦科技有限公司】</strong>
            （统一社会信用代码：91440402MADXADP77R），正式变更为新主体
            <strong>【珠海舒自游国际旅行社有限公司】</strong>
            （统一社会信用代码：91510100MADUL70CXB）。
          </p>
          <p
            style="
              background: #f5f5f5;
              padding: 10px;
              border-left: 3px solid #ccc;
            "
          >
            本次变更为公司内部业务调整，应用的所有功能、服务、已签订的协议及您的账户权益均不会受到任何影响，
            我们将继续竭诚为您提供优质服务。
          </p>

          <h3>二、个人信息转移的说明</h3>
          <p>
            为确保服务的连续性与一致性，根据《中华人民共和国个人信息保护法》第二十二条等相关规定，
            在原主体向新主体转移业务的过程中，将同步转移为提供服务所必需的个人信息。
          </p>
          <ol>
            <li>
              <strong>转移范围：</strong>
              转移的个人信息范围包括您在使用本服务期间提供或产生的：
              <ul>
                <li>a. 账户信息：如昵称、头像、注册手机号。</li>
                <li>
                  b.
                  设备与日志信息：为保障服务安全稳定运行而收集的设备标识符、IP地址等。
                </li>
              </ul>
            </li>
            <li>
              <strong>处理目的与方式：</strong>
              新主体将继续出于原服务目的处理您的个人信息，处理方式不会发生改变。
            </li>
            <li>
              <strong>保护措施：</strong>
              双方将采取加密传输、安全审计等严格的技术与管理措施，确保个人信息在转移过程中的安全，
              防止数据泄露、损毁或丢失。新主体承诺将继续履行原运营主体关于个人信息保护的全部责任与义务。
            </li>
          </ol>

          <h3>三、隐私政策更新</h3>
          <p>
            为反映本次主体变更，我们同步更新了《<strong>ftrip 隐私政策</strong
            >》。
            本次更新主要增加了“服务主体变更与个人信息转移”章节，详细说明了变更情况、信息转移规则及您的权利。
          </p>
          <p>
            更新后的隐私政策将于 【2025年12月20日】 正式生效。
            您可以通过以下路径随时查阅完整政策：
            <a href="javascript:void(0)">应用内“我的-设置-隐私政策”</a>
          </p>

          <h3>四、您的权利</h3>
          <p>
            根据《个人信息保护法》，您享有对个人信息的知情权、决定权等权利。在微信功能运营主体变更后：
          </p>
          <ul>
            <li>新主体将负责继续响应您关于个人信息的各项请求。</li>
            <li>
              如果您不同意变更后的主体继续处理您的信息，您可以依据更新后的隐私政策，通过
              <a href="javascript:void(0)">联系客服</a>
              与我们联系，行使您的相关权利。
            </li>
          </ul>

          <h3>五、其他说明</h3>
          <p>
            此次主体变更已经相关主管部门批准。对于本次变更给您带来的任何不便，我们深表歉意，
            也衷心感谢您的理解与支持！
          </p>
          <p><strong>如有疑问，请拨打客服电话：400-111-9889</strong></p>

          <p style="text-align: right; margin-top: 20px; font-size: 14px">
            【成都百弦科技有限公司】<br />
            【珠海舒自游国际旅行社有限公司】<br />
            2025年12月5日
          </p>
        </div>
      </div>
      <footer>
        <button type="button" class="btn" @click="$emit('closeDialog')">
          我知道了
        </button>
      </footer>
    </div>
  </div>
</template>

<style lang="less" scoped>
.modal-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  z-index: 2000;
  .modal-container {
    width: 32vw;
    border-radius: 0.25rem;
    padding: 1rem;
    background-color: #ffffff;
    box-sizing: border-box;
    margin-top: 15vh;
    box-shadow: 0px 12px 32px 4px rgba(0, 0, 0, 0.04),
      0px 8px 20px rgba(0, 0, 0, 0.08);
  }
  header {
    color: #303331;
    font-size: 1.125rem;
    line-height: 1.5;
    padding-bottom: 1rem;
    position: relative;
    .el-icon {
      position: absolute;
      right: 0;
      top: 0;
      color: #909399;
      height: 1em;
      width: 1em;
      line-height: 1em;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
  .dialog-body {
    max-height: 37.5rem;
    overflow-y: auto;
    text-align: left;
    .simple-notice {
      font-size: 0.875rem; /* 14px */
      line-height: 1.7;
      color: #333;
      max-width: 50rem; /* 800px */
      padding: 0.9375rem; /* 15px */
    }

    .simple-notice h3 {
      font-size: 1rem; /* 16px */
      margin-top: 1.25rem; /* 20px */
      margin-bottom: 0.625rem; /* 10px */
      color: #000;
      font-weight: bold;
      text-align: left;
    }

    .simple-notice p,
    .simple-notice ul,
    .simple-notice ol {
      margin-bottom: 0.75rem; /* 12px */
    }

    .simple-notice ul,
    .simple-notice ol {
      margin-left: 1.25rem; /* 20px */
    }

    .simple-notice a {
      color: #0066cc;
      text-decoration: underline;
    }

    .simple-notice a:hover {
      color: #004080;
    }
  }

  /* 具体按钮类：你可以加 class 控制不同类型 */
  footer {
    margin-top: 1rem;
    .btn {
      display: inline-block;
      padding: 0.5rem 1rem; /* 8px 16px */
      font-size: 0.875rem; /* 14px */
      line-height: 1.4;
      text-align: center;
      border-radius: 0.2rem;
      background-color: #f0f0f0;
      color: #333;
      border: 1px solid #ccc;
      cursor: pointer;
      transition: background-color 0.2s, border-color 0.2s;
    }
  }
}
</style>
